var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgShare = function SvgShare(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 21.6q-.824 0-1.412-.588A1.93 1.93 0 0 1 4 19.6v-11q0-.824.588-1.412A1.93 1.93 0 0 1 6 6.6h2q.424 0 .713.288Q9 7.175 9 7.6q0 .424-.287.713A.97.97 0 0 1 8 8.6H6v11h12v-11h-2a.97.97 0 0 1-.713-.287A.97.97 0 0 1 15 7.6q0-.424.287-.712A.97.97 0 0 1 16 6.6h2q.824 0 1.413.588Q20 7.775 20 8.6v11q0 .825-.587 1.412A1.93 1.93 0 0 1 18 21.6zm5-18.175-.9.9q-.3.3-.7.287a1 1 0 0 1-.7-.312q-.275-.3-.287-.7a.92.92 0 0 1 .287-.7L11.3.3q.3-.3.7-.3t.7.3l2.6 2.6a.93.93 0 0 1 .275.688q0 .412-.275.712-.3.3-.713.3a.97.97 0 0 1-.712-.3L13 3.425V13.6q0 .424-.287.713A.97.97 0 0 1 12 14.6a.97.97 0 0 1-.713-.287A.97.97 0 0 1 11 13.6z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShare);
export { ForwardRef as ReactComponent };